const actionTypes = {
  FetchUserByUid: 'FETCH_USER_BY_UID',
  FetchedReservations: 'FETCH_RESERVATIONS',
  Initialize: 'INITIALIZE',
  LoadCurrentOrder: 'LOAD_CURRENT_ORDER',
};

export default actionTypes;
